module.exports = __webpack_public_path__ + "static/subscription20-c64ad39700d6939a501f33b0178c374e.jpg";